import { PlankPatternForm } from "./PlankPattern.form";

/** One tile photo is enough; the generator reads the tile's proportions and which way it faces. */
export const PennyPatternForm = (props) => (
  <PlankPatternForm
    {...props}
    pattern="penny"
    width={{ value: "2.5", min: 1, max: 10, labelKey: "TILE_WIDTH" }}
    height={{ value: "2.5", min: 1, max: 10, labelKey: "TILE_HEIGHT" }}
  />
);
